import React from 'react'
import RequestBad from 'assets/images/bad-request.png'

const BadRequest = (props) => {

    return (
        <div className='d-flex justify-content-center align-items-center h-100'>
            <div className='d-flex flex-column justify-content-center align-items-center'>
                <img src={RequestBad} className='scheckout-img' />
                <div className="col-12 mx-auto mt-4 text-center">
                    <span className='text-danger text-center text-20 font-weight-600'>
                        This link has expired. <br /> You no longer have access to this !
                    </span>

                </div>
            </div>
        </div>
    )
}

export default BadRequest